import {  Button }              from 'antd';
import React, { useState, useEffect } from 'react';
import "./DeactOrDelete.scss";
import Notification                 from '../../../reuseableComponents/Notification';
import { updateUser, getMyInfoApi } from '../myProfile/apis/apis';
import { useNavigate }   from 'react-router-dom';

const DeactOrDelete = () => {
  const [state, setState] = useState({
    isSuspended:false
  })
  const navigate = useNavigate()

  const deleteFunc = async (bool) => {
    try {
      let result = await updateUser({
        suspended:bool,
        reason:"I am not happy"
      })
      if(result?.status) {
        Notification('success', "Success done", "");
        navigate("/login")
      } else {
        Notification('error', "Error message", "");
      }
    } catch (err) {
      Notification('error', "Error message", "");
    }
  }

  const getMyInfoFunc = async () => {
    try {
      let result = await getMyInfoApi();

      if (result?.status) {
        setState({
          ...state,
          isSuspended: result?.data?.data?.suspended
        })
      }
    }
    catch (err) {
      console.error("Error fetching profile info:", err);
    }
  };

  useEffect(() => {
    getMyInfoFunc()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <div className={ "main-settings-container" }>
    {/*<Radio.Group onChange={ onChange } value={ value }>*/}
    {/*  <Radio value={ "deactivate" }>Deactivate account</Radio>*/}
    {/*  <Radio value={ "delete" }>Delete account</Radio>*/}
    {/*</Radio.Group>*/}
    <Button type={ "primary" } onClick={ () => deleteFunc(!state?.isSuspended) }> { !state?.isSuspended ? "Deactivate account" : "Activate account" }</Button>
  </div>
}

export default DeactOrDelete